import Mutations from '../../odata/mutations';

export default { ...new Mutations('supplier'), ...new Mutations('suppliers') };
